import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { SET_CURRENT_VIDEO } from 'actions/currentVideo';

const INITIAL_STATE = Immutable({
  video: null,
  videoId: null,
  rowId: null,
  isDiscoveryRowVideo: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_CURRENT_VIDEO:
      // TODO: integrate video aggregate and remove action.payload.video
      return state.merge({
        video: action.payload.video,
        videoId: action.payload.videoId,
        rowId: action.payload.rowId,
        isDiscoveryRowVideo: action.payload.isDiscoveryRowVideo,
      });
    default:
      return state;
  }
};
